import { Stack, Typography } from "@mui/material";
import { HStack } from "Components/_Shared/Core/Stack";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Dot } from "./Dot";

const Placeholder = Resources.AnalysisDetail.Goals.Timeline.EmptyStatePlaceholder;

type Props = {
  readOnly: boolean;
  onAddGoal: () => void;
};

export const EmptyTimeline = ({ readOnly, onAddGoal }: Props) => {
  const { t } = useResource();

  return (
    <HStack alignItems="center" gap={Spacing.M} mb={Spacing.XXL}>
      <Dot />

      <Stack
        alignItems="flex-start"
        maxWidth={340}
        p={Spacing.L}
        borderRadius={Radius.L}
        onClick={readOnly ? undefined : onAddGoal}
        sx={(theme) => ({ border: `1px dashed ${theme.colors.borderLight}`, cursor: readOnly ? "default" : "pointer" })}
      >
        <Typography variant="body1" color="secondary" fontWeight={600}>
          {t(Placeholder.Title)}
        </Typography>
        <Typography variant="body2" color="secondary">
          {t(Placeholder.Subtitle)}
        </Typography>
      </Stack>
    </HStack>
  );
};
